var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("error")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Volver a la página de Inicio")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }